import headerNav from './modules/header-nav';
import tiles from './modules/tiles';
import heroSlider from './modules/hero-slider';
import horizontalProductsCarousel from './blocks/horizontal-products-carousel';
import sidebarFilters from './modules/sidebar-filters';
import scrollTo from './modules/scroll-to';
import multiDownload from './modules/multi-download';
import productSearch from './modules/product-search';
import cookies from './modules/cookies';
import errorInit from './modules/error';

require('fslightbox');

document.addEventListener('DOMContentLoaded', () => {
  headerNav.init();
  sidebarFilters.init();
  horizontalProductsCarousel.init();
  tiles();
  heroSlider();
  scrollTo();
  multiDownload();
  productSearch();
  cookies();
  errorInit.errorInit();
});
